import React from "react";
import { Flex } from "../../components/Flex";
import { ProgressBar } from "../../components/Progress";
import { Paragraph } from "../../components/Text";


const UploadProgress = ({ name, progress, status}) => {

    return(
        <Flex direction="column">
            <Paragraph style={{ fontWeight: 700 }} margin={{ bottom: "8px" }}>{name}</Paragraph>
            {status === 3
                ? <ProgressBar progress={progress} status={status} />
                : status < 0
                    ? <Paragraph color="var(--sp-error-hover-color)">Failed</Paragraph>
                    : status === 1
                        ? <Paragraph color="var(--sp-error-hover-color)">Cancelled</Paragraph>
                        : null
            }
        </Flex>
    );
};

export { UploadProgress };